module.exports = __webpack_public_path__ + "static/media/rejected_empty.c233cbd6.svg";